var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title flex-ac"},[_c('img',{attrs:{"src":require("@/assets/images/comp/stitle.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"title_bold",staticStyle:{"padding-left":"8px"}},[_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c232407","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vTitle.vue
// module id = null
// module chunks = 